<!--
File: catalog-action-menu.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Tuesday, 17th December 2024 1:33:24 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div class="flex flex-row gap-2">
  <p-button *ngFor="let button of buttons"
  [pTooltip]="button.label | translate"
  [icon]="button.icon"
  [severity]="button.severity"
  (onClick)="button.action()"
  [raised]="true"
  > </p-button>
</div>
